module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/SBI IRCTC Premier card.c058dcfa.png";